// import { Component, OnInit } from '@angular/core';
// import { MainService } from '../../portal/service/main.service';
// import { AuthenticationService } from '../../authentication.service';

import { Component, AfterViewInit, OnInit, ViewChild } from '@angular/core';
import { MainService } from '../../portal/service/main.service';
import { AuthenticationService } from '../../authentication.service';
import { ProfileService } from '../../portal/service/profile.service';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { ComplaintWorkflowService } from '../../portal/service/complaint-workflow.service';
import { session } from '../../../environments/environment.session';
import { NgSelectComponent } from '@ng-select/ng-select';

import { NgxSpinnerService } from "ngx-spinner";
import { Utf8EncodingService } from '../service/utf8-encoding.service';
@Component({
  selector: 'app-new-header',
  templateUrl: './new-header.component.html',
  styleUrls: ['./new-header.component.css']
})
export class NewHeaderComponent implements OnInit {
  imgURL: any;
  erpUser: any;
  userInfo: any = { first_name: 'UNKNOWN', designation: 'Accountant' }
  @ViewChild('ngSelectElement') ngSelectElement!: NgSelectComponent;
  placeholderText: any
  selectedAction: any
  constructor(private spinner: NgxSpinnerService, public auth: AuthenticationService,
     private complaintworkflowService: ComplaintWorkflowService, 
     private router: Router, private profileService: ProfileService, 
     private sanitizer: DomSanitizer, public mainService: MainService,private utf8EncodingService:Utf8EncodingService) { }
  hidden: any = true;
  accInfo: any = {}
  b_acct_id: any;
  totalForward: any;
  async ngOnInit() {
    if (session?.erpUser) {
      this.erpUser = this.utf8EncodingService.decodeFromUtf8(session['erpUser']);
    }

    if (this.erpUser && +Object.keys(this.erpUser).length) {




      this.b_acct_id = this.erpUser.b_acct_id;
      var dd = [];
      dd = this.erpUser.role_cd
      if (dd.includes("AA")) {
        this.hidden = false;
      } else {
        this.hidden = true
      }


      await this.mainService.getUserImage(this.erpUser['user_id']);
      await this.mainService.getAccImage(this.erpUser['b_acct_id']);
      await this.mainService.getAccountInfo(this.erpUser['b_acct_id']);
      await this.mainService.getHeaderInfo(this.erpUser['b_acct_id']);

      await this.changeLanguage();
      await this.getCount();
      await this.mainService.getMessageCount(this.erpUser['b_acct_id'], this.erpUser['user_id'])
      this.placeholderText = this.erpUser['party_name']

    }
  }
  currentRotation: any = 0;
  async toggle() {
    this.currentRotation += 90;
    var element: any = document.getElementById('hamBurgerLogo');
    element.style.transform = 'rotate(' + this.currentRotation + 'deg)';

    let element2: any = document.getElementById('model');
    if (element2.style.display === 'none' || element2.style.display === '') {
      element2.style.display = 'flex';
    } else {
      element2.style.display = 'none';
    }

    let element3: any = document.getElementById('model2');
    if (element3.style.display === 'none' || element3.style.display === '') {
      element3.style.display = 'flex';
    } else {
      element3.style.display = 'none';
    }
    return
  }
  async getCount() {
    var obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    obj['user_id_to'] = this.erpUser.user_id;
    var resp = await this.complaintworkflowService.getCount(JSON.stringify(obj));
    if (resp['error'] == false) {

      this.totalForward = resp.data[0]['counter'];

    } else {

    }
  }

  changeLanguage() {
    this.mainService.language_cd = this.auth.language_cd
    this.mainService.allLanguage = this.auth.allLanguage
  }

  home() {
    this.router.navigate(['/index'])
  }

  async logOut() {

    sessionStorage.removeItem("1001");
    sessionStorage.removeItem("1000"); sessionStorage.removeItem("1005");
    session.erpUser = undefined
    this.router.navigate(['/login']);

  }


  action = [
    { id: 1, name: 'Profile', route: "profile" },
    { id: 2, name: 'Account', route: "acc" },
    { id: 3, name: 'Logout', route: "login" },

  ];

  toggleSelect() {
    this.ngSelectElement.toggle();
  }
  onSelectionChange2() {
    const selectedVal = this.selectedAction.route
    this.router.navigate([selectedVal]);
  }
}
